import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColumnManagerService } from '../../../services/column-manager/column-manager.service';
import { ColumnManagerDialogData, ColumnConfig, ColumnManagerComponent } from '../column-manager.component';

@Component({
  selector: 'app-column-manager-dialog',
  imports: [ColumnManagerComponent],
  templateUrl: './column-manager-dialog.component.html',
  styleUrl: './column-manager-dialog.component.scss'
})
export class ColumnManagerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ColumnManagerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ColumnManagerDialogData,
    private columnManagerService: ColumnManagerService
  ) { }

  onColumnsChange(config: ColumnConfig) {
    this.columnManagerService.updateTableConfig(this.data.tableId, config);

    if (this.data.autoUpdate) {
      this.dialogRef.close(config);
    }
  }

  onClose() {
    const finalConfig = this.columnManagerService.getTableConfiguration(this.data.tableId);
    this.dialogRef.close(finalConfig ? {
      columns: finalConfig.columns,
      displayedColumns: finalConfig.displayedColumns
    } : undefined);
  }
}
